import screenbanner from "./image/background/1.jpg";
import mobilebanner from "./image/background/2.jpg";

import w from "./image/Location/w.png"
import s from "./image/Location/s.png"
import n from "./image/Location/n.png"
import e from "./image/Location/e.png"






export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};
export const LocationData = {
  taglineheading: "Hot Localities in Bengaluru",
  locationtag: "",
  location: [
    {
      title: "East Bengaluru",
      propertcount: 1,
      image: e,
      link: `/location/bengaluru`,
    },
    {
      title: "West Bengaluru",
      propertcount: 1,
      image: w,
      link: `/location/bengaluru/west`,
    },
  
    {
      title: "North Bengaluru",
      propertcount: 1,
      image: n,
      link: `/location/bengaluru`,
    },
    {
      title: "South Bengaluru",
      propertcount: 1,
      image: s,
      link: `/location/bengaluru`,
    },
    
  ],
};
